
<!--
 * @Description: 
 * @Author: DOJO
 * @Date: 2020-01-17 09:46:20
 * @LastEditTime: 2020-04-02 02:16:51
 * @LastEditors: DOJO
 -->
<template>
  <div class="head-top" :style="{height: headerHeight}">
    <div class="header" id="superHeader" :style="{opacity: 1,paddingTop:paddingTop,height:contPaddingTop}">
      <div class="title">
        <img src="//static.yunjiglobal.com/qnUpload/frontend/hotPage/goabck-b.png" alt="" class="goback flex-1" @click="goBack" >
        <div class="title-tip flex-5">
          <span class="wb">商品提报</span>
        </div>
        <!-- <img src="//static.yunjiglobal.com/qnUpload/frontend/superItem/share_white.png" alt="" class="goback flex-1" @click="goShare" > -->
      </div>
    </div>
    <div class="header top" :style="{backgroundColor: '#fff', opacity: 1,paddingTop:paddingTop,display: opacityNum < 0.1 ? 'none' : ''}">
      <div class="title">
        <img src="//static.yunjiglobal.com/qnUpload/frontend/hotPage/goabck-b.png" alt="" class="goback flex-1" @click="goBack">
        <div class="title-tip flex-5">
          <span class="wb">商品提报</span>
        </div>
        <!-- <img src="//static.yunjiglobal.com/qnUpload/frontend/superItem/share_black.png" alt="" class="goback flex-1" @click="goShare" > -->
      </div>
    </div>
  </div>
</template>

<script>
import YunJi from '@/common/js/YunJi.js'

export default {
  name: 'header-box',
  data() {
    return {
      headerHeight: 'auto',
      opacityNum: 0,
      appCont: YunJi.getUrlParams('appCont') || 0,
      shopId: YunJi.getUrlParams('shopId'),
      isIphoneX: YunJi.isIphoneXall(),
      search: {},
      paddingTop: '0.88rem',
      contPaddingTop: '1.86rem'
    }
  },
  created() {
    this.getAppbarHeight()
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    getAppbarHeight() {
      YunJi.appCommonRule('20190123', 'getStatusBarHeight', undefined, (value) => {
        const devicePixelRatio = window.devicePixelRatio ? window.devicePixelRatio : 1 // 屏幕像素比
        const tempHeader = value / devicePixelRatio 
        this.paddingTop = `${tempHeader}px`
        this.contPaddingTop = `${YunJi.remToPx(0.88) + tempHeader}px`
      })
      //  获取不到状态栏高度时
      const t = setTimeout(() => {
        if (this.appType && this.paddingTop == '0px') {
          const tempHeader = this.isIphoneX ? 44 : 20
          this.paddingTop = `${tempHeader}px`
          this.contPaddingTop = `${YunJi.remToPx(0.88) + tempHeader}px`
        }
        clearTimeout(t)
      }, 100)	
      console.log(this.isIphoneX)
      const tempHeader = this.isIphoneX ? 44 : 10
      let twoHeight = tempHeader * 2
      if (this.isIphoneX) {
        twoHeight = tempHeader
      }
      if (!YunJi.getPhoneType()) {
        twoHeight = tempHeader + 12
      }
      this.headerHeight = `${twoHeight + YunJi.remToPx(0.88) - 6}px`
      this.$emit('handle', tempHeader + YunJi.remToPx(0.88))
    },
    
    // 滚动事件
    handleScroll() {
      const scrollTop = Math.floor(document.body.scrollTop || document.documentElement.scrollTop || window.pageXOffset)
      this.opacityNum = (scrollTop / 120) >= 1 ? 1 : (scrollTop / 120)
    },
    // 左上角返回
    goBack() {
      window.location.href = 'yunji://common/goBack'
    },
    goShare() {
      thinkingReport.track('others', { /* eslint-disable-line */
        page_id: 80468,
        point_id: 24227
      })
      this.$refs.ShareBox.shareData = {
        markOrigin: 'superItem',
        link: `${window.location.origin + window.location.pathname}?shopId=${this.shopId}&appCont=0`,
        title: '超级新品',
        content: '逛新品,来这里就对了~',
        imgUrl: 'https://static.yunjiglobal.com/qnUpload/frontend/superItem/super_share.png'
      }
      this.$refs.ShareBox.show = true
      // window.location.href = `yunji://selection/share?shareSource=2&shareImgUrl=${encodeURIComponent('//static.yunjiglobal.com/qnUpload/frontend/society/share.png')}&shareType=1&shareTitle=${encodeURIComponent('超级新品')}&shareDesc=${encodeURIComponent('逛新品，来这里就对了~')}&shareUrl=${encodeURIComponent(window.origin + window.location.pathname + '?appCont=0&shopId=' + this.shopId + '&hideNavBar=true')}`
    }
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style scoped lang="less">
.head-top{
  background-color: #fff;
  .goback{
    width: .34rem;
    height: .34rem;
    text-align: left;
    display: block;
  }
  .header{
    z-index: 10;
    position: fixed;
    top:0;
    width: 100%;
    align-items: center;
    background: rgba(0,0,0,0);
    background-size: contain;
    line-height: 0.88rem;
    font-size: .22rem;  
    color: #fff;
    text-align: center;
    .flex-1{
      width: .52rem;
      height: .52rem;
      flex-grow: 0;
      flex-shrink: 0;
      flex-basis: .52rem;
    }
    .flex-5{display: flex;flex: 5;align-items: center; justify-content: center;}
    .title{display: flex;padding:.2rem .36rem;align-items: center;}
    .title-tip{
      line-height: .4rem;
    }   
    .wb{
      width: 1.68rem;
      height: .36rem;
      font-size: .32rem;
      font-weight: 500;
      color: #000
    }
    .f-s-11{font-size: .22rem}
    
  }
}
</style>
